<template>
  <div>
    <Modal class="my-modal" v-model="visible" title="从海报管理选择" :mask-closable="false" :footer-hide="true" width="1000px">
      <div class="posterContent">
        <ul class="list">
          <li v-for="(item, index) in columnList" :key="index" @click="clickColum(item)"
            :class="{ 'active': searchParams.columnId == item.id }">
            <span class="listName">{{ item.name }}</span>
            <span>{{ '(' + item.nums + ')' }}</span>
          </li>
        </ul>
        <div class="content">
          <div class="search">
            <div class="searchBox">
              <Input v-model="searchParams.title" placeholder="输入图片名称搜索" class="input" clearable />
              <span class="iconfont iconsousuo" @click="getImgList()"></span>
            </div>
            <Upload ref="upload" :show-upload-list="false" :before-upload="handleUpload" action="/">
              <Button type="primary" style="margin-right: 24px;" @click="visible = false">
                从本地上传
              </Button>
            </Upload>
          </div>
          <div class="imgList">
            <div class="imgBox" v-for="(item, index) in imgList" :key="index" :class="item.check?'getBoder':''">
              <img :src="item.url" :preview="_uid" class="img" :ref="'img' + index" />
              <div class="img-cover" @click.stop="checkImg(item)">
                <img src="@/assets/images/icon/org/gouxuan.png" class="checkImg" v-if="item.check" />
                <img src="@/assets/images/icon/org/openImg.png" @click.stop="handleView(index)" class="openBigImg" />
              </div>
              <div class="imgTitle">{{ item.title }}</div>
            </div>
          </div>
          <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
            style="text-align: center" />
        </div>
      </div>
      <div class="footer">
        <div>
          <span>已选择</span>
          <span>{{ selectIds.length }}</span>
          <span>项</span>
        </div>
        <div>
          <Button type="primary" ghost @click="visible = false;" style="width: 80px;">取消</Button>
          <Button type="primary" style="width: 80px;" @click="submitImg">确定</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props:{
    linkContent:{
      default:[]
    }
  },
  data() {
    return {
      visible: false,
      columnList: [],
      searchParams: {
        columnId: ''
      },
      total: 0,
      pageNo: 1,
      pageSize: 10,
      imgList: [],
      selectIds: [],//已选项
      selectList: [],//已选项信息
    }
  },
  methods: {
    submitImg() {
      if (this.selectList.length > 0 && this.linkContent.length+this.selectList.length<=9) {
        this.$emit('getImg', this.selectList)
        this.visible = false
      } else if(this.selectList.length ==0) {
        this.$notice.error('请至少选择一张海报')
      } else{
        this.$notice.error('总共可上传9张')
      }

    },
    checkImg(arr) {
      this.imgList.forEach((item, index) => {
        if (item.id == arr.id) {
          if (this.selectIds.includes(item.id)) {
            this.selectIds.splice(this.selectIds.indexOf(item.id), 1);
            this.selectList.splice(this.selectIds.indexOf(item.id), 1);
            this.$set(this.imgList[index], 'check', false)
          } else if (!this.selectIds.includes(item.id)) {
            this.selectIds.push(arr.id)
            this.selectList.push(arr.url)
            this.$set(this.imgList[index], 'check', true)
          }
        }
      })
    },
    // 快捷本地上传按钮
    handleUpload(file) {
      this.$emit('uploadImg', file)
    },
    handleView(index) {
      this.$refs['img' + index][0].click();
      this.$previewRefresh();
    },
    checkType(path) {
      return path && path
        .split(".")
        .pop()
        .toLowerCase();
    },
    clickColum(item) {
      this.searchParams.columnId = item.id
      this.pageNo = 1
      this.getImgList()
    },
    pageChange(pageNo) {
      this.pageNo = pageNo
      this.getImgList()
    },
    open() {
      this.selectIds = []
      this.pageNo = 1
      this.visible = true
      this.getColumnList()
      this.selectList = []
      this.searchParams = {
        columnId: ''
      }
      this.getImgList()
    },
    getColumnList() {
      this.$http({
        url: '/buz/cmsPoster/column/list',
        type: "POST",
        data: {
        }
      }).then(res => {
        this.columnList = res.data;
        if (this.columnList.length > 0) {
          this.columnList[0].id = ''
        }
      })
    },
    getImgList() {
      this.$http({
        url: '/buz/cmsPoster/read/list',
        type: "POST",
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          ...this.searchParams
        }
      }).then(res => {
        this.imgList = res.data;
        this.total = res.total;
        this.$previewRefresh();
        this.selectIds.forEach((item) => {
          this.imgList.forEach((i, index) => {
            if (item == i.id) {
              this.$set(this.imgList[index], 'check', true)
            }
          })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-body {
  padding: 0 !important;

}

.posterContent {
  display: flex;

  .list {
    width: 200px;
    border-right: 1px solid #E4E7ED;
    padding-top: 10px;

    .active {
      color: #236DFF;
      background: #F5F7F9;
    }

    .listName {
      display: inline-block;
      padding: 5px 5px 5px 30px;
    }
  }
}

.content {
  width: 100%;
  padding: 20px 0 20px 20px;

  .search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .searchBox {
      display: flex;
      align-items: center;

      /deep/ .ivu-input {
        height: 32px;
      }
    }

    .iconsousuo {
      display: inline-block;
      width: 35px;
      height: 32px;
      background: #236DFF;
      border-radius: 0px 4px 4px 0px;
      color: #fff;
      text-align: center;
      line-height: 32px;
    }

    .input {
      width: 286px;
      height: 32px;
    }
  }

  .imgList {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 344px;


    .imgBox {
      width: 132px;
      height: 134px;
      border: 1px solid #DCDFE6;
      margin-right: 20px;
      margin-bottom: 20px;
      position: relative;

      .img-cover {
        width: 132px;
        height: 132px;
        position: absolute;
        cursor: pointer;
        top: 0;

        .checkImg {
          position: absolute;
          top: 4px;
          left: 6px;
        }

        .openBigImg {
          position: absolute;
          top: 2px;
          right: 5px;
        }
      }

      .img {
        width: 90px;
        height: 130px;
        margin: 0 21px;
        object-fit: cover;
        object-position: top;
      }
    }
    .getBoder{
      border: 2px solid #236DFF;
    }
    .imgTitle{
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 8px;
    }
  }

}

.footer {
  width: 100%;
  height: 70px;
  padding: 0 22px 0 30px;
  border-top: 1px solid #E4E7ED;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  z-index: 1000;
}
</style>